import React from 'react';
import { CaseSearchInput } from './CaseSearchInput';
import { PriorityFilter, PriorityFilterItem } from './PriorityFilter';
import { ArchiveFilter, ArchiveFilterValue } from './ArchiveFilter';
import { MessageSearchTrigger } from './MessageSearchTrigger';
import './curve-theme.css';

type CaseSearchBarBlockProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearch?: () => void;

  priorityItems: PriorityFilterItem[];
  priorityValue: string;
  onPriorityChange: (value: string) => void;

  archiveValue: ArchiveFilterValue;
  onArchiveChange: (value: ArchiveFilterValue) => void;

  onMessageSearchOpen?: () => void;
  isMessageSearchOpen?: boolean;
  onMessageSearchClose?: () => void;
};

export function CaseSearchBarBlock({
  searchValue,
  onSearchChange,
  onSearch,
  priorityItems,
  priorityValue,
  onPriorityChange,
  archiveValue,
  onArchiveChange,
  onMessageSearchOpen,
  isMessageSearchOpen,
  onMessageSearchClose,
}: CaseSearchBarBlockProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--curve-space-xs, 4px)',
        padding: '8px 8px 8px 8px',
        borderBottom: '1px solid var(--curve-border, #E5E5E5)',
      }}
    >
      {/* 搜尋輸入框 */}
      <CaseSearchInput
        value={searchValue}
        onChange={onSearchChange}
        onSearch={onSearch}
      />

      {/* 篩選器列 */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <PriorityFilter
          items={priorityItems}
          value={priorityValue}
          onChange={onPriorityChange}
        />
        <ArchiveFilter value={archiveValue} onChange={onArchiveChange} />
        <div style={{ marginLeft: 'auto' }}>
          <MessageSearchTrigger
            onOpen={onMessageSearchOpen}
            isOpen={isMessageSearchOpen}
            onClose={onMessageSearchClose}
          />
        </div>
      </div>
    </div>
  );
}
